import React from 'react';
import { Route } from 'react-router-dom';
import lazyImport from '../lib/LazyImport.js';

import ManageCourseSurvey from '../pages/Admin/Courses/ManageCourseSurvey.js'; // css order, cba to fix this right
import ManageEventSurvey from '../pages/Admin/Events/ManageEventSurvey.js'; // css order, cba to fix this right
import ManageTrainingSurvey from '../pages/Admin/Training/ManageTrainingSurvey.js';

import PublicApp from './PublicApp.js';

const AdminHome = lazyImport(() => import('../pages/Admin/AdminHome.js'));

const AdminDatabase = lazyImport(
  () => import('../pages/Admin/Database/AdminDatabase.js')
);
const ManageDiscounts = lazyImport(
  () => import('../pages/Admin/Database/ManageDiscounts.js')
);
const ManageDirectDiscounts = lazyImport(
  () => import('../pages/Admin/Database/ManageDirectDiscounts.js')
);
const ManageTerms = lazyImport(
  () => import('../pages/Admin/Database/ManageTerms.js')
);
const ManagePrivacy = lazyImport(
  () => import('../pages/Admin/Database/ManagePrivacy.js')
);
const ManageFAQs = lazyImport(
  () => import('../pages/Admin/Database/ManageFAQs.js')
);
const ManageLecturers = lazyImport(
  () => import('../pages/Admin/Database/ManageLecturers.js')
);
const ManageInstructors = lazyImport(
  () => import('../pages/Admin/Database/ManageInstructors.js')
);
const ManageLecturer = lazyImport(
  () => import('../pages/Admin/Database/ManageLecturer.js')
);
const ManageInstructor = lazyImport(
  () => import('../pages/Admin/Database/ManageInstructor.js')
);
const ManageTags = lazyImport(
  () => import('../pages/Admin/Database/ManageTags.js')
);
const ManageTag = lazyImport(
  () => import('../pages/Admin/Database/ManageTag.js')
);
const ManageTagIcons = lazyImport(
  () => import('../pages/Admin/Database/ManageTagIcons.js')
);
const ManageTagIcon = lazyImport(
  () => import('../pages/Admin/Database/ManageTagIcon.js')
);
const ManageTargetAudiences = lazyImport(
  () => import('../pages/Admin/Database/ManageTargetAudiences.js')
);
const ManageTargetAudience = lazyImport(
  () => import('../pages/Admin/Database/ManageTargetAudience.js')
);
const ManageArticles = lazyImport(
  () => import('../pages/Admin/Database/ManageArticles.js')
);
const ManageArticle = lazyImport(
  () => import('../pages/Admin/Database/ManageArticle.js')
);
const ManageVideos = lazyImport(
  () => import('../pages/Admin/Database/ManageVideos.js')
);
const ManageVideo = lazyImport(
  () => import('../pages/Admin/Database/ManageVideo.js')
);
const ManageCovers = lazyImport(
  () => import('../pages/Admin/Database/ManageCovers.js')
);
const ManageSpecialties = lazyImport(
  () => import('../pages/Admin/Database/ManageSpecialties.js')
);
const ManageUsers = lazyImport(
  () => import('../pages/Admin/Database/ManageUsers.js')
);
const ManageUser = lazyImport(
  () => import('../pages/Admin/Database/ManageUser.js')
);
const ManageAccounts = lazyImport(
  () => import('../pages/Admin/Database/ManageAccounts.js')
);
const ManagePartners = lazyImport(
  () => import('../pages/Admin/Database/ManagePartners.js')
);
const ManagePartner = lazyImport(
  () => import('../pages/Admin/Database/ManagePartner.js')
);

const AdminSponsors = lazyImport(
  () => import('../pages/Admin/Sponsors/AdminSponsors.js')
);
const ManageSponsor = lazyImport(
  () => import('../pages/Admin/Sponsors/ManageSponsor.js')
);
const ManageStand = lazyImport(
  () => import('../pages/Admin/Sponsors/ManageStand.js')
);
const ManageStudy = lazyImport(
  () => import('../pages/Admin/Sponsors/ManageStudy.js')
);
const ManageLink = lazyImport(
  () => import('../pages/Admin/Sponsors/ManageLink.js')
);
const ManageInfo = lazyImport(
  () => import('../pages/Admin/Asset/ManageInfo.js')
);
const ManageDocument = lazyImport(
  () => import('../pages/Admin/Asset/ManageDocument.js')
);
const ManageStandArticle = lazyImport(
  () => import('../pages/Admin/Sponsors/ManageStandArticle.js')
);

const AdminResources = lazyImport(
  () => import('../pages/Admin/Resources/AdminResources.js')
);
const ManageResources = lazyImport(
  () => import('../pages/Admin/Resources/ManageResources.js')
);
const ManageCalculator = lazyImport(
  () => import('../pages/Admin/Resources/ManageCalculator.js')
);
const ManageTree = lazyImport(
  () => import('../pages/Admin/Resources/ManageTree.js')
);
const ManageGuideline = lazyImport(
  () => import('../pages/Admin/Resources/ManageGuideline.js')
);
const ManagePlan = lazyImport(
  () => import('../pages/Admin/Resources/ManagePlan.js')
);
const ManageChecklist = lazyImport(
  () => import('../pages/Admin/Resources/ManageChecklist.js')
);

const AdminCourses = lazyImport(
  () => import('../pages/Admin/Courses/AdminCourses.js')
);
const ManageCourse = lazyImport(
  () => import('../pages/Admin/Courses/ManageCourse.js')
);
const ManageCourseLearning = lazyImport(
  () => import('../pages/Admin/Courses/ManageCourseLearning.js')
);
const ManageCourseQuizzes = lazyImport(
  () => import('../pages/Admin/Courses/ManageCourseQuizzes.js')
);
const ManageCourseEnrolls = lazyImport(
  () => import('../pages/Admin/Courses/ManageCourseEnrolls.js')
);
//const ManageCourseSurvey = lazyImport(() => import("../pages/Admin/Courses/ManageCourseSurvey.js"));
const ManageQuiz = lazyImport(
  () => import('../pages/Admin/Asset/ManageQuiz.js')
);

const AdminTraining = lazyImport(
  () => import('../pages/Admin/Training/AdminTraining.js')
);
const ManageTraining = lazyImport(
  () => import('../pages/Admin/Training/ManageTraining.js')
);
const ManageTrainingEnrolls = lazyImport(
  () => import('../pages/Admin/Training/ManageTrainingEnrolls.js')
);
const ManageTrainingLearning = lazyImport(
  () => import('../pages/Admin/Training/ManageTrainingLearning.js')
);
const ManageSessions = lazyImport(
  () => import('../pages/Admin/Training/ManageSessions.js')
);
const ManageTrainingStatistics = lazyImport(
  () => import('../pages/Admin/Training/ManageTrainingStatistics.js')
);
const ManageTrainingQuiz = lazyImport(
  () => import('../pages/Admin/Training/ManageTrainingQuiz.js')
);

const AdminEvents = lazyImport(
  () => import('../pages/Admin/Events/AdminEvents.js')
);
const ManageEvent = lazyImport(
  () => import('../pages/Admin/Events/ManageEvent.js')
);
const ManageEventTickets = lazyImport(
  () => import('../pages/Admin/Events/ManageEventTickets.js')
);
const ManageEventTicket = lazyImport(
  () => import('../pages/Admin/Events/ManageEventTicket.js')
);
const ManageEventQuizzes = lazyImport(
  () => import('../pages/Admin/Events/ManageEventQuizzes.js')
);
//const ManageEventSurvey = lazyImport(() => import("../pages/Admin/Events/ManageEventSurvey.js"));
const ValidateTicket = lazyImport(
  () => import('../pages/Admin/Events/ValidateTicket.js')
);

const AdminFolhetos = lazyImport(() => import('../leaflets/AdminFolhetos.js'));
const ManageFolheto = lazyImport(() => import('../leaflets/ManageFolheto.js'));

const AdminExercises = lazyImport(
  () => import('../exercises/AdminExercises.js')
);
const ManageExercise = lazyImport(
  () => import('../exercises/ManageExercise.js')
);

const AdminShop = lazyImport(() => import('../store/AdminShop.js'));
const AdminStoreAdd = lazyImport(() => import('../store/AdminStoreAdd.js'));
const AdminStoreCover = lazyImport(() => import('../store/AdminStoreCover.js'));
const AdminStoreManageOrders = lazyImport(
  () => import('../store/AdminStoreManageOrders.js')
);
const AdminStoreEditOrder = lazyImport(
  () => import('../store/AdminStoreEditOrder.js')
);
const AdminShopLayout = lazyImport(() => import('../store/AdminShopLayout.js'));

const AdminLanguages = lazyImport(
  () => import('../pages/Admin/Languages/AdminLanguages.js')
);
const ManageCountries = lazyImport(
  () => import('../pages/Admin/Languages/ManageCountries.js')
);
const ManageLanguages = lazyImport(
  () => import('../pages/Admin/Languages/ManageLanguages.js')
);
const ManagePrices = lazyImport(
  () => import('../pages/Admin/Languages/ManagePrices.js')
);
const ManageCurrencies = lazyImport(
  () => import('../pages/Admin/Languages/ManageCurrencies.js')
);
const AddCountry = lazyImport(
  () => import('../pages/Admin/Languages/AddCountry.js')
);
const AddLanguage = lazyImport(
  () => import('../pages/Admin/Languages/AddLanguage.js')
);
const AddPrice = lazyImport(
  () => import('../pages/Admin/Languages/AddPrice.js')
);
const AddCurrency = lazyImport(
  () => import('../pages/Admin/Languages/AddCurrency.js')
);
const ManagePaymentMethods = lazyImport(
  () => import('../pages/Admin/Languages/ManagePaymentMethods.js')
);
const ManageTrainingFAQs = lazyImport(
  () => import('../pages/Admin/Database/ManageTrainingFAQs.js')
);

const AdminApp = () => (
  <PublicApp>
    {/* databaseroutes.map(... path="/admin/database" + route.path) element= route.comeponent */}

    <Route path="/admin/shop" element={<AdminShop />} />
    <Route path="/admin/shop/manage/:itemType" element={<AdminShopLayout />} />
    <Route
      path="/admin/shop/manage/:itemType/add"
      element={<AdminStoreAdd />}
    />
    <Route
      path="/admin/shop/manage/:itemType/:itemId/edit"
      element={<AdminStoreAdd />}
    />
    <Route path="/admin/shop/manage/covers" element={<AdminStoreCover />} />
    <Route
      path="/admin/shop/manage/orders"
      element={<AdminStoreManageOrders />}
    />
    <Route
      path="/admin/shop/manage/orders/:orderId"
      element={<AdminStoreEditOrder />}
    />

    <Route path="/admin/resources/exercises" element={<AdminExercises />} />
    <Route path="/admin/resources/exercises/add" element={<ManageExercise />} />
    <Route
      path="/admin/resources/exercises/:resourceId/edit"
      element={<ManageExercise />}
    />

    <Route path="/admin/resources/folhetos" element={<AdminFolhetos />} />
    <Route path="/admin/resources/folhetos/add" element={<ManageFolheto />} />
    <Route
      path="/admin/resources/folhetos/:resourceId/edit"
      element={<ManageFolheto />}
    />

    <Route path="/admin" element={<AdminHome />} />
    <Route path="/admin/database" element={<AdminDatabase />} />

    <Route path="/admin/database/discounts" element={<ManageDiscounts />} />
    <Route
      path="/admin/database/direct-discounts"
      element={<ManageDirectDiscounts />}
    />
    <Route path="/admin/database/users" element={<ManageUsers />} />
    <Route path="/admin/database/users/:userId/edit" element={<ManageUser />} />
    <Route path="/admin/database/lecturers" element={<ManageLecturers />} />
    <Route path="/admin/database/lecturers/add" element={<ManageLecturer />} />
    <Route
      path="/admin/database/lecturers/:lecturerId/edit"
      element={<ManageLecturer />}
    />
    <Route path="/admin/database/instructors" element={<ManageInstructors />} />
    <Route
      path="/admin/database/instructors/add"
      element={<ManageInstructor />}
    />
    <Route
      path="/admin/database/instructors/:instructorId/edit"
      element={<ManageInstructor />}
    />
    <Route path="/admin/database/specialties" element={<ManageSpecialties />} />
    <Route path="/admin/database/tags" element={<ManageTags />} />
    <Route path="/admin/database/tags/:type/add" element={<ManageTag />} />
    <Route
      path="/admin/database/tags/:type/:tagId/edit"
      element={<ManageTag />}
    />
    <Route path="/admin/database/tag-icons" element={<ManageTagIcons />} />
    <Route path="/admin/database/tag-icons/add" element={<ManageTagIcon />} />
    <Route
      path="/admin/database/tag-icons/:tagIconId/edit"
      element={<ManageTagIcon />}
    />
    <Route
      path="/admin/database/target-audience"
      element={<ManageTargetAudiences />}
    />
    <Route
      path="/admin/database/target-audience/add"
      element={<ManageTargetAudience />}
    />
    <Route
      path="/admin/database/target-audience/:targetAudienceId/edit"
      element={<ManageTargetAudience />}
    />
    <Route path="/admin/database/accounts" element={<ManageAccounts />} />
    <Route path="/admin/database/faqs" element={<ManageFAQs />} />
    <Route
      path="/admin/database/training-faqs"
      element={<ManageTrainingFAQs />}
    />
    <Route path="/admin/database/terms" element={<ManageTerms />} />
    <Route path="/admin/database/privacy" element={<ManagePrivacy />} />
    <Route path="/admin/database/covers" element={<ManageCovers />} />
    <Route path="/admin/database/videos" element={<ManageVideos />} />
    <Route path="/admin/database/videos/add" element={<ManageVideo />} />
    <Route
      path="/admin/database/videos/:videoId/edit"
      element={<ManageVideo />}
    />
    <Route path="/admin/database/articles" element={<ManageArticles />} />
    <Route path="/admin/database/articles/add" element={<ManageArticle />} />
    <Route
      path="/admin/database/articles/:articleId/edit"
      element={<ManageArticle />}
    />

    <Route path="/admin/database/partners" element={<ManagePartners />} />
    <Route path="/admin/database/partners/add" element={<ManagePartner />} />
    <Route
      path="/admin/database/partners/:partnerId/edit"
      element={<ManagePartner />}
    />

    <Route path="/admin/sponsors" element={<AdminSponsors />} />
    <Route path="/admin/sponsors/add" element={<ManageSponsor />} />
    <Route path="/admin/sponsors/:sponsorId/edit" element={<ManageSponsor />} />
    <Route
      path="/admin/sponsors/:sponsorId/stands/add"
      element={<ManageStand />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/edit"
      element={<ManageStand />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/articles/add"
      element={<ManageArticle />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/articles/:articleId/edit"
      element={<ManageArticle />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/documents/add"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/documents/:documentId/edit"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/infos/add"
      element={<ManageInfo />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/infos/:infoId/edit"
      element={<ManageInfo />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/links/add"
      element={<ManageLink />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/links/:linkId/edit"
      element={<ManageLink />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/studies/add"
      element={<ManageStudy />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/studies/:studyId/edit"
      element={<ManageStudy />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/videos/add"
      element={<ManageVideo />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/videos/:videoId/edit"
      element={<ManageVideo />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/standarticles/add"
      element={<ManageStandArticle />}
    />
    <Route
      path="/admin/sponsors/stands/:standId/standarticles/:linkId/edit"
      element={<ManageStandArticle />}
    />

    <Route path="/admin/resources" element={<AdminResources />} />
    <Route
      path="/admin/resources/:resourceType"
      element={<ManageResources />}
    />
    <Route
      path="/admin/resources/calculators/add"
      element={<ManageCalculator />}
    />
    <Route
      path="/admin/resources/calculators/:resourceId/edit"
      element={<ManageCalculator />}
    />
    <Route path="/admin/resources/tables/add" element={<ManageCalculator />} />
    <Route
      path="/admin/resources/tables/:resourceId/edit"
      element={<ManageCalculator />}
    />
    <Route path="/admin/resources/trees/add" element={<ManageTree />} />
    <Route
      path="/admin/resources/trees/:resourceId/edit"
      element={<ManageTree />}
    />
    <Route
      path="/admin/resources/guidelines/add"
      element={<ManageGuideline />}
    />
    <Route
      path="/admin/resources/guidelines/:resourceId/edit"
      element={<ManageGuideline />}
    />
    <Route path="/admin/resources/plans/add" element={<ManagePlan />} />
    <Route
      path="/admin/resources/plans/:resourceId/edit"
      element={<ManagePlan />}
    />
    <Route
      path="/admin/resources/checklists/add"
      element={<ManageChecklist />}
    />
    <Route
      path="/admin/resources/checklists/:resourceId/edit"
      element={<ManageChecklist />}
    />
    <Route path="/admin/resources/infos/add" element={<ManageInfo />} />
    <Route
      path="/admin/resources/infos/:resourceId/edit"
      element={<ManageInfo />}
    />

    <Route path="/admin/courses" element={<AdminCourses />} />
    <Route path="/admin/courses/add" element={<ManageCourse />} />
    <Route path="/admin/courses/:courseId/edit" element={<ManageCourse />} />
    <Route
      path="/admin/courses/:courseId/edit/enrollments"
      element={<ManageCourseEnrolls />}
    />
    <Route
      path="/admin/courses/:courseId/edit/quizzes"
      element={<ManageCourseQuizzes />}
    />
    <Route
      path="/admin/courses/:courseId/edit/learning"
      element={<ManageCourseLearning />}
    />
    <Route
      path="/admin/courses/:courseId/edit/surveys"
      element={<ManageCourseSurvey />}
    />
    <Route
      path="/admin/courses/:courseId/videos/add"
      element={<ManageVideo />}
    />
    <Route
      path="/admin/courses/:courseId/videos/:videoId/edit"
      element={<ManageVideo />}
    />
    <Route
      path="/admin/courses/:courseId/documents/add"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/courses/:courseId/documents/:documentId/edit"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/courses/:courseId/quizzes/add"
      element={<ManageQuiz />}
    />
    <Route
      path="/admin/courses/:courseId/quizzes/:quizId/edit"
      element={<ManageQuiz />}
    />

    <Route path="/admin/training" element={<AdminTraining />} />
    <Route path="/admin/training/add" element={<ManageTraining />} />
    <Route
      path="/admin/training/:trainingId/edit"
      element={<ManageTraining />}
    />
    <Route
      path="/admin/training/:trainingId/edit/enrollments"
      element={<ManageTrainingEnrolls />}
    />
    <Route
      path="/admin/training/:trainingId/edit/sessions"
      element={<ManageSessions />}
    />
    <Route
      path="/admin/training/:trainingId/edit/learning"
      element={<ManageTrainingLearning />}
    />
    <Route
      path="/admin/training/:trainingId/documents/add"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/training/:trainingId/documents/:documentId/edit"
      element={<ManageDocument />}
    />
    <Route
      path="/admin/training/:trainingId/edit/surveys"
      element={<ManageTrainingSurvey />}
    />
    <Route
      path="/admin/training/:trainingId/session/:sessionId/quizzes/add"
      element={<ManageQuiz />}
    />
    <Route
      path="/admin/training/:trainingId/session/:sessionId/quizzes/:quizId/edit"
      element={<ManageQuiz />}
    />
    <Route
      path="/admin/training/:trainingId/edit/statistics"
      element={<ManageTrainingStatistics />}
    />
    <Route
      path="/admin/training/:trainingId/edit/final-quiz"
      element={<ManageTrainingQuiz />}
    />

    <Route path="/admin/events" element={<AdminEvents />} />
    <Route path="/admin/events/add" element={<ManageEvent />} />
    <Route path="/admin/events/:eventId/edit" element={<ManageEvent />} />
    <Route
      path="/admin/events/:eventId/edit/tickets"
      element={<ManageEventTickets />}
    />
    <Route
      path="/admin/events/:eventId/edit/quizzes"
      element={<ManageEventQuizzes />}
    />
    <Route
      path="/admin/events/:eventId/edit/surveys"
      element={<ManageEventSurvey />}
    />
    <Route path="/admin/events/:eventId/quizzes/add" element={<ManageQuiz />} />
    <Route
      path="/admin/events/:eventId/quizzes/:quizId/edit"
      element={<ManageQuiz />}
    />
    <Route path="/admin/events/validate" element={<ValidateTicket />} />

    <Route
      path="/admin/events/:eventId/tickets/:ticketId/edit"
      element={<ManageEventTicket />}
    />
    <Route
      path="/admin/events/:eventId/tickets/add"
      element={<ManageEventTicket />}
    />

    <Route path="/admin/languages" element={<AdminLanguages />} />

    <Route path="/admin/languages/countries" element={<ManageCountries />} />

    <Route path="/admin/languages/countries/add" element={<AddCountry />} />

    <Route
      path="/admin/languages/countries/:countryId/edit"
      element={<AddCountry />}
    />

    <Route path="/admin/languages/languages" element={<ManageLanguages />} />

    <Route path="/admin/languages/languages/add" element={<AddLanguage />} />

    <Route
      path="/admin/languages/languages/:languageId/edit"
      element={<AddLanguage />}
    />

    <Route path="/admin/languages/prices" element={<ManagePrices />} />

    <Route path="/admin/languages/prices/add" element={<AddPrice />} />

    <Route
      path="/admin/languages/prices/:priceId/edit"
      element={<AddPrice />}
    />

    <Route path="/admin/languages/currencies" element={<ManageCurrencies />} />

    <Route path="/admin/languages/currencies/add" element={<AddCurrency />} />

    <Route
      path="/admin/languages/currencies/:currencyId/edit"
      element={<AddCurrency />}
    />

    <Route
      path="/admin/languages/paymentmethods"
      element={<ManagePaymentMethods />}
    />
  </PublicApp>
);

export default AdminApp;
